export default __webpack_public_path__ + "static/media/whatsAppRealcase.92c7ffa4.png";